export interface TradingStrategyEditorLoadingStateInput {
    isAccessSummaryLoading: boolean;
    hasPersistedStrategy: boolean;
    isCopySourceLoading: boolean;
    isEditMode: boolean;
    isFormHydrating: boolean;
    isRouteStrategyIdValid: boolean;
    isStrategyFetchSuccess: boolean;
    isStrategyLoading: boolean;
}

export interface TradingStrategyEditorLoadingState {
    isLoading: boolean;
    loadingText: string;
    showMissingStrategy: boolean;
}

export interface TradingStrategyEditorAuxiliaryQueryStateInput {
    hasCopySourceStrategy: boolean;
    hasPersistedStrategy: boolean;
    isCopyMode: boolean;
    isEditMode: boolean;
    isStrategyFetchSuccess: boolean;
    strategyId: number | null;
}

export interface TradingStrategyEditorAuxiliaryQueryState {
    canLoadPersistedStrategyAuxiliaryData: boolean;
    canLoadStrategyEditorAuxiliaryData: boolean;
}

export const getTradingStrategyEditorLoadingState = ({
    hasPersistedStrategy,
    isAccessSummaryLoading,
    isCopySourceLoading,
    isEditMode,
    isFormHydrating,
    isRouteStrategyIdValid,
    isStrategyFetchSuccess,
    isStrategyLoading
}: TradingStrategyEditorLoadingStateInput): TradingStrategyEditorLoadingState => {
    const loadingReasons = [
        isRouteStrategyIdValid && isStrategyLoading ? 'strategy details' : null,
        isFormHydrating ? 'strategy form' : null,
        isAccessSummaryLoading ? 'access permissions' : null,
        isCopySourceLoading ? 'source strategy' : null
    ].filter((reason): reason is string => reason !== null);

    return {
        isLoading: loadingReasons.length > 0,
        loadingText: loadingReasons.length > 0 ? `Loading ${loadingReasons.join(' and ')}...` : 'Loading...',
        showMissingStrategy: isEditMode && (!isRouteStrategyIdValid || (isStrategyFetchSuccess && !hasPersistedStrategy))
    };
};

export const getTradingStrategyEditorAuxiliaryQueryState = ({
    hasCopySourceStrategy,
    hasPersistedStrategy,
    isCopyMode,
    isEditMode,
    isStrategyFetchSuccess,
    strategyId
}: TradingStrategyEditorAuxiliaryQueryStateInput): TradingStrategyEditorAuxiliaryQueryState => {
    const canLoadStrategyEditorAuxiliaryData = isEditMode
        ? isStrategyFetchSuccess && hasPersistedStrategy
        : !isCopyMode || hasCopySourceStrategy;

    return {
        canLoadPersistedStrategyAuxiliaryData: isEditMode && strategyId !== null && canLoadStrategyEditorAuxiliaryData,
        canLoadStrategyEditorAuxiliaryData
    };
};

export const parseTradingStrategyRouteId = (id: string | undefined): number | null => {
    if (!id || id === 'new') return null;

    const parsedId = Number(id);

    return Number.isInteger(parsedId) && parsedId > 0 ? parsedId : null;
};
